// import { createClient } from '@supabase/supabase-js'

// const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
// const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// export const supabase = createClient(supabaseUrl, supabaseKey)

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl) {
  console.error('REACT_APP_SUPABASE_URL is undefined')
}

if (!supabaseKey) {
  console.error('REACT_APP_SUPABASE_ANON_KEY is undefined')
}

const DEFAULT_SITE_URL = 'https://jmolux.com'

/** Redirect target for signup verification, password reset, and resend emails. */
export const getAuthRedirectUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/`
  }
  const siteUrl = (process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).replace(/\/$/, '')
  return `${siteUrl}/`
}

export const supabase = createClient(supabaseUrl, supabaseKey)